export const MostPopular = 'Most popular'
export const BestMatch = 'Best match'
export const SORT_BY_POPULARITY = 'popularity'
export const SORT_BY_MOST_POPULAR = 'mostpopular'
export const BEST_MATCH_ID = 'bestmatch'
export const SORT_BY_FEATURED = 'featured'
